import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { getCurrentOrganization } from 'ducks/organizations'
import { useFunnelTracking } from 'hooks/useFunnelTracking'
import { startSessionRecording } from 'utils/mixpanel'

import Button from 'components/Shared/Button'
import EmptyState from 'components/Shared/EmptyState'
import SheetBridgeIcon from './SheetBridgeIcon'

const SheetBridgeCard = ({ appId }) => {
  const history = useHistory()
  const { trackClickedSheetBridge } = useFunnelTracking()
  const currentOrganization = useSelector(getCurrentOrganization)
  const sheetBridgeUrl = `/apps/${appId}/data/sheetbridge`

  const handleTryOut = () => {
    if (currentOrganization?.id) {
      startSessionRecording()
      trackClickedSheetBridge(currentOrganization.id).catch(error => {
        console.error('Failed to track SheetBridge click:', error)
      })
    }
    history.push(sheetBridgeUrl)
  }

  return (
    <EmptyState bordered className="sheetbridge-empty-state">
      <div className="sheetbridge-logo-header">
        <span className="sheet-text">Sheet</span>
        <SheetBridgeIcon className="bridge-icon" variant="teal" />
        <span className="bridge-text">Bridge</span>
      </div>
      <p>
        Sync your Google Sheets data in real-time.
        <br />
        Build powerful apps with spreadsheet-backed collections.
      </p>
      <Button
        small
        red
        className="sheetbridge-try-button"
        onClick={handleTryOut}
      >
        TRY OUT
      </Button>
    </EmptyState>
  )
}

export default SheetBridgeCard
